import { AlertIcon, Button, Flex, Typography } from '@iheartjane/reefer';

interface WizardErrorProps {
  onTryAgain: () => void;
}

export function WizardError({ onTryAgain }: WizardErrorProps) {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap={16}
      justifyContent="center"
      p={24}
      height="100%"
    >
      <AlertIcon color="grays-light" size="xl" mb={8} />
      <Typography variant="h2-semibold" textAlign="center">
        We hit a snag generating your matches.
      </Typography>
      <Typography textAlign="center">
        Your answers are saved &ndash; try again and we&rsquo;ll pick up where
        you left off.
      </Typography>
      <Button variant="primary" label="Try again" onClick={onTryAgain} mt={8} />
    </Flex>
  );
}
